import { Box, Skeleton } from '@coolblue-development/freddy';

export const ProfileMenuSkeleton = (): JSX.Element => {
  return (
    <Box>
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
    </Box>
  );
};
